import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/freeflow.svg'
import _imports_1 from '@/assets/freeflow_spawner.png'


const _hoisted_1 = { class: "flex flex-col justify-around relative items-center min-h-screen" }
const _hoisted_2 = {
  key: 0,
  class: "loader ease-linear rounded-full border-4 inline-block h-12 w-12 border-4"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row justify-center items-center mt-10 mb-5" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "h-16",
    src: _imports_0,
    alt: "FreeFlow logo"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row justify-center items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "h-80",
    src: _imports_1,
    alt: "FreeFlow spawner"
  })
], -1)
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h1", { class: "uppercase text-center" }, [
  /*#__PURE__*/_createTextVNode(" Welcome to your"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", { class: "font-bold" }, "freeflow experiences.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "font-medium text-base" }, "Please enter your ThreeFold Connect username in order to continue.", -1)
const _hoisted_9 = { class: "mt-5 h-72 flex flex-col items-center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "" }, "Do you want to run the decentralized FreeFlow machine on your own machine", -1)
const _hoisted_11 = { class: "flex flex-col items-center" }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "text-left max-w-md self-start" }, "1. Install Docker", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", null, "2. Run your own FreeFlow environment inside a Docker", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "text-black" }, "/////", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "fixed left-0 top-0 bg-red-700 text-white uppercase text-xl z-[9999] px-16 transform -rotate-45 -translate-x-16 translate-y-2 opacity-50 pointer-events-none" }, " Beta ", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "absolute bottom-2" }, [
  /*#__PURE__*/_createTextVNode(" Powered by "),
  /*#__PURE__*/_createVNode("a", {
    class: "underline color-primary",
    href: "https://threefold.io/"
  }, "ThreeFold")
], -1)

import { ref } from 'vue';
    import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';
    import { spawn } from '@/service/spawnService';
    import { ChevronUpIcon } from '@heroicons/vue/solid';
    import { useRoute } from 'vue-router';

    
export default _defineComponent({
  expose: [],
  setup(__props) {

    const route = useRoute();
    const name = ref((route.query.username as string) ?? null);
    const USERNAME = '{{ USERNAME }}';

    const loginAndSpawn = () => {
        if (!name.value) return;

        const actualName = name.value.toLowerCase().trim().split('.3bot')[0];
        spawn(actualName);
    };

    if (name.value) loginAndSpawn();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_unref(route).query.username)
      ? (_openBlock(), _createBlock("div", _hoisted_2))
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (name.value = $event)),
              type: "text",
              class: "py-2 uppercase text-center bg-[#e3dbd5] block w-full sm:text-base border-transparent text-gray-900 rounded-md mt-7",
              pattern: "[0-9a-zA-Z\\.]",
              placeholder: "Username",
              onKeyup: _withKeys(loginAndSpawn, ["enter"])
            }, null, 40, ["onKeyup"]), [
              [_vModelText, name.value]
            ]),
            _createVNode("button", {
              class: "py-2 px-4 mt-2 text-white rounded-md bg-[#66c9bf]",
              onClick: loginAndSpawn
            }, "GO!")
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_unref(Disclosure), null, {
              default: _withCtx(({ open }) => [
                _createVNode(_unref(DisclosureButton), { class: "flex justify-between items-center" }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _createVNode(_unref(ChevronUpIcon), {
                      class: [{ 'rotate-180': !open }, "w-5 h-5 text-gray-500 transform mx-2"]
                    }, null, 8, ["class"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(DisclosurePanel), {
                  style: {"width":"28rem"},
                  class: "px-4 pt-4 pb-2 text-sm text-gray-500"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_unref(Disclosure), null, {
                        default: _withCtx(({ open }) => [
                          _createVNode(_unref(DisclosureButton), { class: "flex justify-between items-center self-start" }, {
                            default: _withCtx(() => [
                              _hoisted_13,
                              _createVNode(_unref(ChevronUpIcon), {
                                class: [{ 'rotate-180': !open }, "w-5 h-5 text-gray-500 transform mx-2"]
                              }, null, 8, ["class"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(DisclosurePanel), { class: "max-w-md flex justify-center" }, {
                            default: _withCtx(() => [
                              _createVNode("div", { class: "bg-black text-white mt-2 p-4 h-16 overflow-x-scroll overflow-y-hidden whitespace-nowrap rounded-md" }, [
                                _createVNode("p", { class: "text-white text-left" }, [
                                  _createTextVNode(" docker run -ti --sysctl net.ipv6.conf.all.disable_ipv6=0 -e \"USER_ID=" + _toDisplayString(USERNAME) + "\" -e \"DIGITALTWIN_APPID=digitaltwin-local.jimbertesting.be\" -e \"ENVIRONMENT=staging\" --cap-add=NET_ADMIN --device=/dev/net/tun:/dev/net/tun -p 443:443 threefoldjimber/digitaltwin:latest "),
                                  _hoisted_14
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode("p", { class: "text-left max-w-md mt-2 self-start" }, [
                        _createTextVNode(" 3. Browse to https://" + _toDisplayString(USERNAME) + ".digitaltwin-local.jimbertesting.be"),
                        _hoisted_15,
                        _createTextVNode(" 4. Replace " + _toDisplayString(USERNAME) + " with your own name. ")
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _hoisted_16,
          _hoisted_17
        ]))
  ]))
}
}

})